import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function TeachersPage() {
  return <InstituteCrudPage config={entityConfigs['teachers']} />;
}
